import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import ContactClient from './pages/ContactClient';
import ContactEntreprise from './pages/ContactEntreprise';
import NotFound from './pages/NotFound';
import About from './pages/About';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import AdminPayments from './admin/AdminPayments';
import CGV from './pages/CGV';
import OrderTracking from './pages/OrderTracking';
import PaymentSuccess from './pages/PaymentSuccess';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Routes publiques avec Layout (Header + Footer) */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/cv" element={<Layout><About /></Layout>} />
          <Route path="/portfolio" element={<Layout><Portfolio /></Layout>} />
          <Route path="/contact-client" element={<Layout><ContactClient /></Layout>} />
          <Route path="/contact-entreprise" element={<Layout><ContactEntreprise /></Layout>} />
           <Route path="/mentions-legales" element={<Layout><MentionsLegales /></Layout>} />
          <Route path="/politique-confidentialite" element={<Layout><PolitiqueConfidentialite /></Layout>} />
           <Route path="/cgv" element={<Layout><CGV /></Layout>} />
          

          <Route path="/order/:paymentId" element={<OrderTracking />} />
          <Route path="/checkout/:paymentId" element={<OrderTracking />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />

          <Route path="*" element={<Layout><NotFound /></Layout>} />
          
          {/* Routes admin SANS Layout */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />

           <Route 
            path="/admin/payments" 
            element={
              <ProtectedRoute>
                <AdminPayments />
              </ProtectedRoute>
            } 
          />

        </Routes>
      </div>
    </Router>
  );
}

export default App;